export enum AttachmentTypeEnum {
  PHOTO = 'PHOTO',
  EXAMINATION = 'EXAMINATION',
  PRESCRIPTION = 'PRESCRIPTION',
  UNKNOWN = 'UNKNOWN',
  REFUND = 'REFUND',
}
